@if (isInspectionsOnlyAccount) {
  <im-inspection-details-timelog></im-inspection-details-timelog>
}

@if (isTimeManagementOnlyAccount) {
  <mat-button-toggle-group
    [value]="toggleValue"
    appearance="legacy"
    name="timelogToggle"
    aria-label="timelogToggle"
    hideSingleSelectionIndicator
  >
    <mat-button-toggle
      (change)="toggleValue = $event.value"
      value="timesheet"
      >Inspection Timesheet</mat-button-toggle
    >
  </mat-button-toggle-group>
  <mat-card appearance="outlined">
    <mat-card-content>
      <div class="tab-content">
        <im-inspection-timelog-timesheet></im-inspection-timelog-timesheet>        
      </div>
    </mat-card-content>
  </mat-card>
}

@if (isInspectionsAndTimeManagementAccount) {
  <mat-button-toggle-group
    [value]="toggleValue"
    appearance="legacy"
    name="timelogToggle"
    aria-label="timelogToggle"
    hideSingleSelectionIndicator
  >
    <mat-button-toggle
      (change)="toggleValue = $event.value"
      value="timelog"
      >Inspection Timelog</mat-button-toggle
    >

    @if (hasInspectorRole) {
       <mat-button-toggle
        (change)="toggleValue = $event.value"
        value="timesheet"
        >Inspection Timesheet</mat-button-toggle
      >
    }
  </mat-button-toggle-group>
  <mat-card appearance="outlined">
    <mat-card-content>
      <div class="tab-content">
        @if (toggleValue === 'timelog') {
          <im-inspection-details-timelog></im-inspection-details-timelog>
        }
        @if (toggleValue === 'timesheet') {
          <im-inspection-timelog-timesheet></im-inspection-timelog-timesheet>
        }
      </div>
    </mat-card-content>
  </mat-card>
}